import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { ModalProps } from "./Modal.types";
import styles from "./modal.module.scss";

export const Modal: React.FC<ModalProps> = (props: ModalProps) => {
  const wrapperClassNames = classNames({
    [styles.wrapperWithOverlay]: props.withOverlay,
    [styles.wrapper]: !props.withOverlay,
    [props.additionalWrapperClassName]: props.additionalWrapperClassName,
  });

  const contentClassNames = classNames({
    [styles.contentWithOverlay]: props.withOverlay,
    [styles.content]: !props.withOverlay,
    [props.additionalContentClassName]: props.additionalContentClassName,
  });

  const renderContent = () => {
    return (
      <div className={wrapperClassNames}>
        <div className={contentClassNames}>{props.children}</div>
      </div>
    );
  };

  return props.isOpen
    ? props.usePortal
      ? ReactDOM.createPortal(
          renderContent(),
          document.querySelector("[id='portals']") || document.body
        )
      : renderContent()
    : null;
};

export default Modal;
